import React from 'react';
import './Dashboard.scss';
import TopDashboard from './TopDashboard';
import GraphDashboard from './Graph/Graph';

const Dashboard = () => {
  return (
    <>
      <TopDashboard />
      <GraphDashboard />
    </>
  );
};

export default Dashboard;
